import { useModal } from '@ebay/nice-modal-react'
import { Link, useMatches } from '@tanstack/router'
import { useTranslation } from 'react-i18next'

import casino from '../../assets/common/casino.webp'
import deportes from '../../assets/common/deportes.webp'
import free_bonus from '../../assets/common/free-bonus.webp'
import halo from '../../assets/common/halo.svg'
import promotions from '../../assets/common/promotions.webp'
import useGeoCheck from '../../hooks/useGeoCheck'
import { useBoundStore } from '../../store/store'
import LoginModal from '../common/log-in-modal'

const BottomNav = () => {
  const pending_bind = useBoundStore(state => state.user.pending_bind)
  const setIsPendingDepositVisible = useBoundStore(
    state => state.common.setIsPendingDepositVisible,
  )
  const username = useBoundStore(state => state.user.username)
  const { geoCheck } = useGeoCheck()
  const logInModal = useModal(LoginModal)
  const { t } = useTranslation('drawer')
  const matches = useMatches()
  const fullPath = matches.slice(-1)[0].route.fullPath as string

  const TABS = [
    {
      icon: deportes,
      label: t('sports'),
      link: +pending_bind === 0 || +pending_bind === 2 ? undefined : '/sports',
      onLinkClick: () => {
        if (+pending_bind === 0 || +pending_bind === 2)
          setIsPendingDepositVisible(true)
      },
      isProtected: false,
    },
    {
      icon: casino,
      label: 'CASINO',
      link: '/casino/lobby',
      onLinkClick: null,
      isProtected: false,
    },
    {
      icon: promotions,
      label: t('promotions'),
      link: '/promotions',
      isProtected: false,
    },
    {
      icon: free_bonus,
      label: t('bonus'),
      link: '/profile/free-bonus',
      onLinkClick: null,
      isProtected: true,
    },
  ] as const

  return (
    <div className="fixed rounded-full w-[calc(100%-32px)] bottom-2 left-4 z-20 bg-[rgba(255,255,255,0.75)] dark:bg-[rgba(10,10,10,0.75)] grid grid-cols-4 px-3 h-[60px] items-center transition-all duration-[0.2s] ease-[ease-in-out] border border-solid border-[color-mix(in_srgb,var(--highlight-gold)_25%,transparent)] dark:border-[color-mix(in_srgb,var(--highlight-gold)_35%,transparent)] shadow-[0px_-2px_5px_color-mix(in_srgb,var(--highlight-gold)_15%,transparent)] dark:shadow-[0_0_12px_color-mix(in_srgb,var(--highlight-gold)_30%,transparent)]">
      {TABS.map(tab => (
        <Link
          to={tab.isProtected && !username ? undefined : tab.link}
          key={tab.label}>
          <div
            className={`flex flex-col items-center group ${
              tab.link && fullPath.includes(tab.link) ? 'active' : ''
            }`}
            onClick={() => {
              if (tab.isProtected && !username) {
                geoCheck(logInModal.show)
              }
            }}>
            <div className="w-10 h-10 rounded-full flex justify-center items-center transition-all duration-200 ease-in-out mb-0.5 relative">
              <img
                src={halo}
                className={`absolute top-0 left-0 w-10 h-10 transition-all duration-200 ease-in-out animate-[rotate_2s_linear_infinite] ${
                  tab.link && fullPath.includes(tab.link)
                    ? 'opacity-100'
                    : 'opacity-0'
                }`}
              />
              <div className="w-10 h-10 object-contain">
                <img src={tab.icon} alt={tab.label} />
              </div>
            </div>
            <p
              className={`text-[8px] font-['Syncopate-Bold'] uppercase text-center ${
                tab.link && fullPath.includes(tab.link)
                  ? 'text-[#df0033]'
                  : 'text-[var(--txt)]'
              }`}>
              {tab.label}
            </p>
          </div>
        </Link>
      ))}
    </div>
  )
}

export default BottomNav
